// extracted by mini-css-extract-plugin
export default {"wrapper":"Section7_wrapper__zU-tn","section7":"Section7_section7__OxP4P"};